import getBITSEndApiMap from "../apiMap";
import { api } from "../services/AxiosService";

export async function getSettings() {
  let url = getBITSEndApiMap("themeConfiguration");
  const response = await api.get(url);
  return response.data;
}
export async function getConfiguration() {
  let url = getBITSEndApiMap("configuration");
  const response = await api.get(url);
  return response.data;
}
export interface ThemeSettingsPayload {
  institutionName: string;
  supportEmail: string;
  logoUrl: string;
  maintenanceAlert: boolean;
  maintenanceMessage: string;
  sandboxConfig?: {
    mode: "local" | "cloud";
    idleTimeoutMinutes?: number;
  };
  appearance: {
    primaryColor: string;
    navigationColor: string;
  };
  emailNotifications: boolean;
  pushNotifications: boolean;
  adminAlerts: boolean;
}

export async function updateSettings(payload: ThemeSettingsPayload) {
  console.log("updateSettings payload", payload);
  let url = getBITSEndApiMap("themeConfiguration");
  let response = await api.put(url, payload);
  return response;
}

export interface LmsToolConfigurationPayload {
  platformName: string;
  platformId: string;
  clientId: string;
  authLoginUrl: string;
  authTokenUrl: string;
  keySetUrl: string;
  deploymentId: string;
}

export async function getLmsToolConfiguration() {
  const url = getBITSEndApiMap("lmsToolConfiguration");
  const response = await api.get(url);
  return response.data;
}

export async function lmsToolConfiguration(
  payload: LmsToolConfigurationPayload,
) {
  const url = getBITSEndApiMap("lmsToolConfiguration");
  const response = await api.post(url, payload);
  return response;
}

/*************************** Fishbone API ******************************/
export interface FishboneApiKeyPayload {
  apiKey: string;
  name?: string;
  expiryDays?: number;
}

export interface FishboneApiKeyResponse {
  configured: boolean;
  name?: string;
  isActive?: boolean;
  isExpired?: boolean;
  expiresAt?: string;
  lastUsedAt?: string;
  createdAt?: string;
  encrypted_key?: string;
}

export async function getFishboneApiKey(): Promise<FishboneApiKeyResponse> {
  const url = getBITSEndApiMap("fishboneApiKey");
  const response = await api.get(url);
  return response.data;
}

export async function saveFishboneApiKey(payload: FishboneApiKeyPayload) {
  const url = getBITSEndApiMap("fishboneApiKey");
  const response = await api.post(url, payload);
  return response.data;
}

export async function deleteFishboneApiKey() {
  const url = getBITSEndApiMap("fishboneApiKey");
  const response = await api.delete(url);
  return response.data;
}
